import { render, staticRenderFns } from "./user-guidance.vue?vue&type=template&id=6cf6ff2c&scoped=true"
import script from "./user-guidance.vue?vue&type=script&lang=js"
export * from "./user-guidance.vue?vue&type=script&lang=js"
import style0 from "./user-guidance.vue?vue&type=style&index=0&id=6cf6ff2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6ff2c",
  null
  
)

export default component.exports